import Path from "@core/FileProvider/Path/Path";
import RouterPathProvider from "@core/RouterPath/RouterPathProvider";
import { expandShortEditorPath, isShortEditorPath } from "@ext/enterprise/pathname/shortEditorPath";

export const getNotificationArticlePathname = (articleUrl: string): string => {
	const segments = RouterPathProvider.parseItemLogicPath(new Path(articleUrl)).fullPath;
	if (!RouterPathProvider.isEditorPathname(segments)) return articleUrl;

	const editorSegments = isShortEditorPath(segments) ? expandShortEditorPath(segments) : segments;
	const { repNameItemLogicPath } = RouterPathProvider.parseEditorPath(editorSegments);
	return RouterPathProvider.getReadOnlyPathname(new Path(repNameItemLogicPath).value);
};
